import React, { useEffect, useState, useRef } from "react";
import { DateTime } from "luxon";
import { useStateContext } from "../contexts/ContextProvider";
import aimSound from "../data/sounds/aim-sound.mp3";
import {
  apiCreateConversation,
  apiCreateMessage,
  apiUpdateConversation,
} from "../services/apiService";

const Chatbox = (props) => {
  const { senderId, recipientId } = props;
  const { user, messages, setMessages, conversations, setConversations } =
    useStateContext();
  const [message, setMessage] = useState({});
  const [origSender, setOrigSender] = useState(false);
  const [height, setHeight] = useState("h-[365px]");

  const currentConversation = conversations.find(
    (x) =>
      (x.senderId === senderId && x.recipientId === recipientId) ||
      (x.senderId === recipientId && x.recipientId === senderId)
  );

  let currentMessages = [];
  let currentMessagesSorted = [];

  if (currentConversation) {
    currentMessages = messages.filter(
      (x) => x.conversationId === currentConversation.id
    );
  }

  // console.log("shit:", senderId, recipientId);

  if (currentMessages) {
    currentMessagesSorted = currentMessages.sort((a, b) =>
      a.timeSent > b.timeSent ? 1 : -1
    );
  }

  const myInput = useRef(null);

  useEffect(() => {
    if (currentConversation.senderId === user.id) {
      currentConversation.viewedBySender = true;
      setOrigSender(true);
    } else {
      currentConversation.viewedByRecipient = true;
    }

    if (window.innerHeight >= 700 && window.innerHeight < 800)
      setHeight("h-[350px]");
    if (window.innerHeight >= 800 && window.innerHeight < 900)
      setHeight("h-[450px]");
    if (window.innerHeight >= 900 && window.innerHeight < 1000)
      setHeight("h-[550px]");
    if (window.innerHeight >= 1000) setHeight("h-[675px]");

    const element = document.getElementById(senderId);
    element.scrollTop = element.scrollHeight;

    // eslint-disable-next-line
  }, [conversations]); // messages, senderId, conversations

  const handleChange = (event) => {
    let { value } = event.target;
    // let newId;
    // if (messages.length === 0) {
    //   newId = 1;
    // } else {
    //   newId = messages[messages.length - 1].id + 10;
    // }

    //remove 'new line' characters
    if (/[\r\n]$/.test(value)) {
      value = "";
    }

    setMessage((prevState) => ({
      ...prevState,
      message: value,
      conversationId: currentConversation.id,
      senderId,
      recipientId,
      timeSent: DateTime.utc().toISO(), // All times should be coverted to/from GMT
    }));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      myInput.current?.click();
    }
  };
  const playSound = () => {
    let sound = document.getElementById("aim");
    sound.play();
  };

  const handleSubmit = async () => {
    if (message.message === "") {
      //TODO: add standard error handling
      console.log("no message");
      return;
    } else {
      //api calls
      createMessage();
      updateConversation();

      setMessage({
        senderId: "",
        recipientId: "",
        timeSent: "",
        message: "",
      });
      playSound();
    }
  };

  console.log(currentConversation);

  const createMessage = async () => {
    console.log("creating message", message);
    const response = await apiCreateMessage(message);
    if (response.hasError) {
      //TODO: add error message
      console.log("message failed");
      return;
    } else {
      setMessages((prevState) => [...prevState, response.data]);
      console.log("message created");
    }
  };

  const updateConversation = async () => {
    // update conversation details for current message
    if (message.message) {
      currentConversation.lastMessage = message.message.slice(0, 40);
      currentConversation.timeOfLastMessage = message.timeSent;
    }
    if (origSender) {
      currentConversation.viewedBySender = true;
      currentConversation.viewedByRecipient = false;
    } else {
      currentConversation.viewedBySender = false;
      currentConversation.viewedByRecipient = true;
    }

    // update conversation
    const response = await apiUpdateConversation(
      currentConversation.id,
      currentConversation
    );

    if (response.hasError) {
      //TODO: add error message
      return;
    } else {
      setConversations(
        conversations.toSpliced(
          conversations.findIndex((x) => x.id === message.conversationId),
          1,
          response.data
        )
      );
    }
  };

  return (
    <div className="justify-items-center mb-60">
      <audio id="aim">
        <source src={`${aimSound}`} type="audio/mpeg" />
      </audio>
      <div className="px-5 py-3 mb-0">
        {/*  'h-svh' went somewhere above or below */}
        <div className="grid justify-items-center">
          Chatting With:
          <span className="text-snappily-orange capitalize pb-2">
            {senderId === currentConversation.senderId
              ? currentConversation.recipientsName
              : currentConversation.sendersName}{" "}
            - {currentConversation.streetAddress}
          </span>
        </div>
        <div
          id={senderId}
          className={`bg-white border-gray-400 border-2 rounded-2xl 
          overflow-y-scroll scroll-p-10 px-2 ${height}`}
        >
          <ul id="messages">
            {currentMessagesSorted.map((item, index) => {
              return (
                <li
                  id={messages.length - 1 === index ? "end" : ""}
                  key={item.id || index}
                  className={`grid text-lg my-2
                ${
                  item.senderId === senderId
                    ? "text-blue-500 justify-items-end"
                    : "text-snappily-orange"
                }

                `}
                >
                  <p
                    className={`w-72 break-words text-pretty
                      ${
                        item.senderId === senderId
                          ? item.message.length >= 37
                            ? `text-justify`
                            : `text-right`
                          : item.message.length >= 37
                          ? `text-left`
                          : `text-justify`
                      } `}
                  >
                    {item.message}
                  </p>

                  <span className="text-xs text-gray-300 italic">
                    {DateTime.fromISO(item.timeSent).toFormat("DD-HH:mm:ss")}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="flex justify-between pt-5">
          <div className="w-full pr-2">
            <textarea
              className="w-full text-lg border-gray-400 border-2 rounded-lg p-3 placeholder:italic"
              type="text"
              name="message"
              placeholder="Enter message here..."
              autoFocus={true}
              value={message.message}
              maxLength="100"
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            ></textarea>
          </div>
          <div>
            <input
              ref={myInput}
              type="button"
              value="Send"
              onClick={() => handleSubmit()}
              className="bg-blue-500 text-white hover:bg-green-500 hover:drop-shadow-xl
             border-black border-1 rounded-xl p-2 focus:outline-white hover:border-white"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chatbox;
